import React, { useEffect, useState } from "react";
import {
  AsideBar,
  LeftArrow,
  RightArrow,
  Plus,
  Reload,
  CloseSquare,
  Lock,
  Share,
  Sheald,
  Tabs,
  Close,
  Expand,
  Colapse,
  Money,
  San,
  Pencil,
  Batery,
  Netwoks,
  WiFi,
  Book,
} from "../../assets/apple-icons/exports";
import BrowserCMS from "./BrowserCMS";
import BrowserShop from "./BrowserShop";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function SecondSection() {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isHovered, setHovered] = useState(false);
  const [isHoveredLink, setHoveredLink] = useState(false);
  const [activeUrl, setActiveUrl] = useState(2);
  const [isMobile, setMobile] = useState(false);
  const [size, setSize] = useState({
    width: undefined,
    height: undefined,
  });

  // Show current time
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formattedTime = currentTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
  // Show current time

  //resize page
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (size.width < 685) {
      setMobile(true);
      setActiveUrl(1);
    } else {
      setMobile(false);
      setActiveUrl(2);
    }
  }, [size.width]);
  //resize page

  const handleUrlClick = (urlNumber) => {
    if (urlNumber !== activeUrl) {
      setActiveUrl(urlNumber);
    }
  };

  //text effect
  useEffect(() => {
    const elts = {
      text1: document.getElementById("text1"),
      text2: document.getElementById("text2"),
    };

    const texts = ["simple", "modern", "fast", "secure", "good", "safe"];

    const morphTime = 1.5;
    const cooldownTime = 0.25;

    let textIndex = texts.length - 1;
    let time = new Date();
    let morph = 0;
    let cooldown = cooldownTime;

    elts.text1.textContent = texts[textIndex % texts.length];
    elts.text2.textContent = texts[(textIndex + 1) % texts.length];

    function doMorph() {
      morph -= cooldown;
      cooldown = 0;

      let fraction = morph / morphTime;

      if (fraction > 1) {
        cooldown = cooldownTime;
        fraction = 1;
      }

      setMorph(fraction);
    }

    function setMorph(fraction) {
      elts.text2.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
      elts.text2.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

      fraction = 1 - fraction;
      elts.text1.style.filter = `blur(${Math.min(8 / fraction - 8, 100)}px)`;
      elts.text1.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

      elts.text1.textContent = texts[textIndex % texts.length];
      elts.text2.textContent = texts[(textIndex + 1) % texts.length];
    }

    function doCooldown() {
      morph = 0;

      elts.text2.style.filter = "";
      elts.text2.style.opacity = "100%";

      elts.text1.style.filter = "";
      elts.text1.style.opacity = "0%";
    }

    function animate() {
      requestAnimationFrame(animate);

      let newTime = new Date();
      let shouldIncrementIndex = cooldown > 0;
      let dt = (newTime - time) / 1000;
      time = newTime;

      cooldown -= dt;

      if (cooldown <= 0) {
        if (shouldIncrementIndex) {
          textIndex++;
        }

        doMorph();
      } else {
        doCooldown();
      }
    }

    animate();
  }, []);

  // gsap

  gsap.registerPlugin(ScrollTrigger);

  useGSAP(() => {
    const entries = document.querySelectorAll(".second .entry");
    entries.forEach((entry) => {
      let entryMain = entry.querySelectorAll(".entry_main");
      let entrySecondary = entry.querySelectorAll(".entry_secondary");
      let popup = entry.querySelectorAll(".pop-scroll");

      gsap.set(entryMain, {
        xPercent: -150,
        opacity: 0,
      });
      gsap.set(entrySecondary, {
        xPercent: 150,
        opacity: 0,
      });
      gsap.set(popup, {
        yPercent: 50,
        xPercent: 50,
        opacity: 0,
      });
      gsap.to(entryMain, {
        scrollTrigger: {
          trigger: entry,
          start: "top bottom",
          end: "bottom 90%",
          scrub: true,
        },
        xPercent: 0,
        opacity: 1,
      });
      gsap.to(entrySecondary, {
        scrollTrigger: {
          trigger: entry,
          start: "10% bottom",
          end: "bottom 90%",
          scrub: true,
        },
        xPercent: 0,
        opacity: 1,
      });
      gsap.to(popup, {
        scrollTrigger: {
          trigger: entry,
          start: "10% bottom",
          end: "bottom 80%",
          scrub: true,
        },
        yPercent: 0,
        xPercent: 0,
        opacity: 1,
      });
    });
  });

  return (
    <section className="container second">
        <div className="content entry">
          <div className="popup pop-scroll">
            <div className="pencil">
              <Pencil />
            </div>
            <div className="poptext">
              Re-design your web-site
              <span>
                <div id="container">
                  <div id="text1"></div>
                  <div id="text2"></div>
                </div>
                <svg id="filters">
                  <defs>
                    <filter id="threshold">
                      <feColorMatrix
                        in="SourceGraphic"
                        type="matrix"
                        values="1 0 0 0 0
									0 1 0 0 0
									0 0 1 0 0
									0 0 0 255 -140"
                      />
                    </filter>
                  </defs>
                </svg>
              </span>
            </div>
          </div>
          <div className="entry_main top-trigger">
            <div className="browser">
              <div className="cover"></div>
              {isMobile !== true ? (
                <div className="navbar">
                  <div className="left-side">
                    <div
                      className="control-buttons"
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                    >
                      <div className="dot close">{isHovered && <Close />}</div>
                      <div className="dot colapse">
                        {isHovered && <Colapse />}
                      </div>
                      <div className="dot expand">
                        {isHovered && <Expand />}
                      </div>
                    </div>
                    <AsideBar />
                    <div className="arrows">
                      <LeftArrow />
                      <RightArrow />
                    </div>
                  </div>
                  <div className="center">
                    <Sheald />
                    <div className="search-box">
                      <div
                        className={`url ${activeUrl === 1 ? "active" : ""}`}
                        onClick={() => {
                          handleUrlClick(1);
                          setHoveredLink(true);
                        }}
                        onMouseEnter={() => {
                          if (activeUrl === 1) setHoveredLink(true);
                        }}
                        onMouseLeave={() => {
                          if (activeUrl === 1) setHoveredLink(false);
                        }}
                      >
                        <div className="link">
                          <div className="close">
                            {activeUrl === 1 ? <CloseSquare /> : <San />}
                          </div>
                          <div className="nowrapper">
                            <p>Product Listing</p>
                          </div>
                          <div
                            style={{
                              opacity: activeUrl === 1 ? 1 : 0,
                            }}
                          >
                            <Lock />
                          </div>
                        </div>
                        <div
                          className="reload"
                          style={{
                            opacity: activeUrl === 1 && isHoveredLink ? 1 : 0,
                          }}
                        >
                          <Reload />
                        </div>
                      </div>
                      <div
                        className={`url ${activeUrl === 2 ? "active" : ""}`}
                        onClick={() => {
                          handleUrlClick(2);
                          setHoveredLink(true);
                        }}
                        onMouseEnter={() => {
                          if (activeUrl === 2) setHoveredLink(true);
                        }}
                        onMouseLeave={() => {
                          if (activeUrl === 2) setHoveredLink(false);
                        }}
                      >
                        <div className="link">
                          <div className="close">
                            {activeUrl === 2 ? <CloseSquare /> : <Money />}
                          </div>
                          <div className="nowrapper">
                            <p>Financial CRM</p>
                          </div>
                          <div
                            style={{
                              opacity: activeUrl === 2 ? 1 : 0,
                            }}
                          >
                            <Lock />
                          </div>
                        </div>
                        <div
                          className="reload"
                          style={{
                            opacity: activeUrl === 2 && isHoveredLink ? 1 : 0,
                          }}
                        >
                          <Reload />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="right-side">
                    <Share />
                    <Plus />
                    <Tabs />
                  </div>
                </div>
              ) : (
                <div className="navbar">
                  <p>{formattedTime}</p>
                  <span></span>
                  <div className="icons">
                    <Netwoks />
                    <WiFi />
                    <Batery />
                  </div>
                </div>
              )}
              {activeUrl === 2 ? <BrowserCMS /> : <BrowserShop />}
              {isMobile && (
                <div className="sub-navbar">
                  <div className="urls">
                    <div className="url-item-sec"></div>
                    <div className="url-item">
                      <Lock />
                      <p>Product Listing</p>
                      <Reload />
                    </div>
                    <div className="url-item-sec"></div>
                  </div>
                  <div className="icons">
                    <LeftArrow />
                    <RightArrow />
                    <Share />
                    <Book />
                    <Tabs />
                  </div>
                  <span></span>
                </div>
              )}
            </div>
          </div>
          <div className="info entry_secondary">
            <h3>Transforming Businesses with Innovative Website Solutions</h3>
            <p>
              We offer customizable website solutions tailored to your specific
              business goals and requirements.
            </p>
          </div>
        </div>
    </section>
  );
}
